import "@aws-amplify/ui-react/styles.css";
import React from "react";
import TeamDisplay from "../controls/TeamDisplay";
import BasePage from "../controls/BasePage";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import { BuildFilter } from "../utilities/TeamFiltering";
import { useParams } from "react-router-dom";

class ViewTeam extends BasePage {
    render() {
        if (this.state.data == null) {
            return <LoadingBlock />;
        }
        
        const location = window.location;
        const paths  = location.pathname.split('/');
        const teamId = paths[paths.length -1];

        const team = this.state.data.Teams.find(t => t.id === teamId);
        const filter = BuildFilter();

        if (team == null) {
            return <NotFound message="Team Not Found"/>;
        }
        return (
            <TeamDisplay team={team} siteData={this.state.data} filterData={filter} isAuthenticated={this.props.isAuthenticated} />
        );
    }
}

function ViewTeamWrapper(props: {isAuthenticated: boolean}) {
    const id = useParams();
    return (<ViewTeam teamId={id} isAuthenticated={props.isAuthenticated} />);
}
export default ViewTeamWrapper;